import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Button, Form, Header,  Icon,  Loader,  Select, Table } from 'semantic-ui-react';
import { cutliststatusreport,dropTitleCode } from '../../app/models/Restoration';
import { useStore } from '../../app/stores/store';
import './style.css';

const Cutliststatusreport = () => {
  const { RestorationStore,userStore: { user }, } = useStore();
  const [friendOptions,setFriendOptions]=useState<dropTitleCode[]>([]);
  const [leadOptions, setLeadOptions] = useState<dropTitleCode[]>([]);
  const [ReelOptions, setReelOptions] = useState<dropTitleCode[]>([]);
  const [CutlistStatusOptions, setCutlistStatusOptions] = useState<dropTitleCode[]>([]);
  const [employeeNameOptions, setEmployeeNameOptions] = useState<dropTitleCode[]>([]);
  const [selectedTitle, setSelectedTitle] = useState<string>('');
  const [selectedLead, setSelectedLead] = useState<string>('');
  const [selectedReel, setSelectedReel] = useState<string>('');
  const [selectedCutliststatus, setSelectedCutliststatus] = useState<string>('');
  const [selectedEmployeeName, setSelectedEmployeeName] = useState<string>('');
  const [filteredData, setFilteredData] = useState<cutliststatusreport[]>([]);
  const [loading, setLoading] = useState(false);
  
  const handleChange = (e:any, data:any) => {
    setSelectedTitle(data.value);
    CutlistAPICall(data.value);
  };

  const titleCodeData=async()=>{
    await RestorationStore.getLiveTitleCode();
    const projectCode = RestorationStore.dropTitleCode;
    setFriendOptions(projectCode);
    }

  const CutlistAPICall=async (titleCode:string) =>{
    if(titleCode!=='')
    {
      setFilteredData([])
      setSelectedTitle(titleCode);
      setLoading(true);
      await RestorationStore.cutlistStatusreport(titleCode);
      setFilteredData(RestorationStore.cutlistStatusReportData);
      setLoading(false);
    }
  }

  const CsvConvert=()=>{
    const rows=[];
    
    const titleCodeRow=[
        'Cluster Name',
        'Employee ID',
        'Employee Name',
        'Title Code',
        'Reel Name',
        'Shot Name',
        'Resolution',
        'Start Frame',
        'End Frame',
        'Total Frame',
        'QC Approved',
        'FQA Approved',
        'CQC Approved',
        'Cutlist Status',
        'Owner',
        
    ];
   
    rows.push(titleCodeRow.join(','));
    filteredData.forEach(item => {
        const values = Object.values(item);
        rows.push(values.join(','));
    });
    const csvContent = rows.join('\n');
    return csvContent;
  }
  const handleDownload = () => {
    const csvContent = CsvConvert();
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${selectedTitle}_CutlistStatus.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

  useEffect(() => {
   
    if (selectedLead === '' && selectedReel === '' && selectedCutliststatus ==='' && selectedEmployeeName ==='' ) 
      {
        setFilteredData(RestorationStore.cutlistStatusReportData);
        setLeadOptions([]);
        setReelOptions([]);
        setCutlistStatusOptions([]);
        setSelectedCutliststatus('');
        setSelectedEmployeeName('');
        setSelectedReel('');
        setSelectedLead('');
          const temp = Array.from(
            new Map(
              RestorationStore.cutlistStatusReportData.map((data: cutliststatusreport) => [data.leadId, data])
            ).values()
          ).map((data: cutliststatusreport,index: number) => {
            return {
              key: index,
              text: data.leadId,
              value: data.leadId,
            };
          });
          setLeadOptions(temp);
          const Reeltemp = Array.from(
            new Map(
              RestorationStore.cutlistStatusReportData.map((data: cutliststatusreport) => [data.reel_Name, data])
            ).values()
          ).map((data: cutliststatusreport,index: number) => {
            return {
              key: index,
              text: data.reel_Name,
              value: data.reel_Name,
            };
          });
          setReelOptions(Reeltemp);
          const ReelCutlisttemp = Array.from(
            new Map(
              RestorationStore.cutlistStatusReportData.map((data: cutliststatusreport) => [data.title_Status, data])
            ).values()
          ).map((data: cutliststatusreport,index: number) => {
            return {
              key: index,
              text: data.title_Status,
              value: data.title_Status,
            };
          });
          setCutlistStatusOptions(ReelCutlisttemp);
          const employeetemp = Array.from(
            new Map(
              RestorationStore.cutlistStatusReportData.map((data: cutliststatusreport) => [data.employee_Name, data])
            ).values()
          ).map((data: cutliststatusreport,index: number) => {
            return {
              key: index,
              text: data.employee_Name,
              value: data.employee_Name,
            };
          });
          setEmployeeNameOptions(employeetemp);
    } 
    else
    {
      const filterData = (data: cutliststatusreport[]) => {
        return data.filter(
          (item) =>
            (selectedCutliststatus === '' || item.title_Status === selectedCutliststatus) &&
            (selectedReel === '' || item.reel_Name === selectedReel) &&
            (selectedLead === '' || item.leadId === selectedLead) &&
            (selectedEmployeeName === '' || item.employee_Name === selectedEmployeeName)
        );
      };
      const FilterDataMapping=(keySelector: (data: cutliststatusreport) => string)=>{
        return Array.from(
          new Map(filterData(filteredData).map((data) => [keySelector(data), data])).values()
        ).map((data, index) => ({
          key: index,
          text: keySelector(data),
          value: keySelector(data),
        }));
      }
      const employeetemp1 = FilterDataMapping((data) => data.employee_Name);
      setEmployeeNameOptions(employeetemp1);
      const ReelCutlisttemp1 = FilterDataMapping((data) => data.title_Status);
      setCutlistStatusOptions(ReelCutlisttemp1);
      const temp1 = FilterDataMapping((data) => data.leadId);
      setLeadOptions(temp1);
      const Reeltemp1 = FilterDataMapping((data) => data.reel_Name);
      setReelOptions(Reeltemp1);
    }
    // eslint-disable-next-line
  }, [RestorationStore.cutlistStatusReportData,selectedCutliststatus,selectedEmployeeName,selectedLead,selectedReel]);

useEffect(()=>{
  titleCodeData();
// eslint-disable-next-line
},[])
  
  return (
    <>
      <div>
        <div className="title_wise_cutlistreport">
          <Header>Cutlist Status Report</Header>
          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px', position: 'sticky', top: 0, zIndex: 2, background: 'white' }}>
  <div className="tr-dropdown" style={{ display: 'flex', alignItems: 'center' }}>
    <label>Title Code:</label>
    <Select
      placeholder="Select Title code"
      selection
      search
      clearable
      options={friendOptions}
      value={selectedTitle}
      onChange={handleChange}
    />
  </div>

  {filteredData.length !== 0 && (
    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
        <label style={{ marginLeft: '12px' }}>Lead ID:</label>
        <Select
          placeholder="Select Lead ID"
          selection
          search
          clearable
          options={leadOptions}
          value={selectedLead}
          disabled={selectedTitle === ''}
          onChange={(e:any, data:any) => { setSelectedLead(data.value); }}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
        <label style={{ marginLeft: '12px' }}>Reel Name:</label>
        <Select
          placeholder="Select Reel Name"
          selection
          search
          clearable
          options={ReelOptions}
          value={selectedReel}
          disabled={selectedTitle === ''}
          onChange={(e:any, data:any) => { setSelectedReel(data.value); }}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
        <label style={{ marginLeft: '12px' }}>Employee Name:</label>
        <Select
          placeholder="Select Employee Name"
          selection
          search
          clearable
          options={employeeNameOptions}
          value={selectedEmployeeName}
          disabled={selectedTitle === ''}
          onChange={(e:any, data:any) => { setSelectedEmployeeName(data.value); }}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
        <label style={{ marginLeft: '12px' }}>Cutlist Status:</label>
        <Select
          placeholder="Select Cutlist Status"
          selection
          search
          clearable
          options={CutlistStatusOptions}
          value={selectedCutliststatus}
          disabled={selectedTitle === ''}
          onChange={(e:any, data:any) => { setSelectedCutliststatus(data.value); }}
        />
      </div>
        {user?.departmentName !=='Colorization' && (
          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                <Form.Field>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button onClick={handleDownload}><Icon className='download' /></Button>
                  </div>
                </Form.Field>
              </div>
        )}
      
    </div>
  )}
</div>
          <br/>
          <div style={{ height: '900px', overflow: 'auto' }}>
          <Table>
          <Table.Header style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
              <Table.Row >
                <Table.HeaderCell>Cluster Name</Table.HeaderCell>
                <Table.HeaderCell>Employee ID</Table.HeaderCell>
                <Table.HeaderCell>Employee Name</Table.HeaderCell>
                <Table.HeaderCell>Title Code</Table.HeaderCell>
                <Table.HeaderCell>Reel Name</Table.HeaderCell>
                <Table.HeaderCell>Shot Name</Table.HeaderCell>
                <Table.HeaderCell>Resolution</Table.HeaderCell>
                <Table.HeaderCell>Start Frame</Table.HeaderCell>
                <Table.HeaderCell>End Frame</Table.HeaderCell>
                <Table.HeaderCell>Total Frame</Table.HeaderCell>
                {user?.departmentName!=='Colorization' && 
                (
                  <> 
                  <Table.HeaderCell>QC Approved</Table.HeaderCell>
                  <Table.HeaderCell>FQA Approved </Table.HeaderCell>
                  <Table.HeaderCell>CQC Approved </Table.HeaderCell>
                  </>
                )}
                <Table.HeaderCell>Cutlist Status</Table.HeaderCell>
                <Table.HeaderCell>Current Stage(Owner)</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
            
              {selectedTitle.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan={11} textAlign="center">
                    Please Select Title code..
                  </Table.Cell>
                </Table.Row>
              )}
            {loading  && selectedTitle.length !== 0 && (
                            <Table.Row>
                              <Table.Cell colSpan={11} textAlign="center">
                                <Loader active inline='centered' size='massive' />
                              Please wait, this will take a few minutes...
                              </Table.Cell>
                            </Table.Row>
                          )}
              {selectedTitle.length !== 0 && filteredData.length === 0 && loading === false && (
                <Table.Row>
                  <Table.Cell colSpan={11} textAlign="center">
                    Data is currently unavailable
                  </Table.Cell>
                </Table.Row>
              )}
              {selectedTitle.length !== 0 &&
                filteredData.length !== 0 &&
                filteredData.filter((item) => (selectedCutliststatus==='' || item.title_Status===selectedCutliststatus)
                && ((selectedReel === '' || item.reel_Name === selectedReel)) && ((selectedLead === '' || item.leadId === selectedLead)) 
                && ((selectedEmployeeName === '' || item.employee_Name === selectedEmployeeName)))
                .map((Items, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>{Items.leadId}</Table.Cell>
                    <Table.Cell>{Items.employee_ID}</Table.Cell>
                    <Table.Cell>{Items.employee_Name}</Table.Cell>
                    <Table.Cell>{Items.title_Code}</Table.Cell>
                    <Table.Cell>{Items.reel_Name}</Table.Cell>
                    <Table.Cell>{Items.shot_Name}</Table.Cell>
                    <Table.Cell>{Items.resolution}</Table.Cell>
                    <Table.Cell>{Items.start_Frame}</Table.Cell>
                    <Table.Cell>{Items.end_Frame}</Table.Cell>
                    <Table.Cell>{Items.total_Frame}</Table.Cell>
                    {user?.departmentName!=='Colorization' && (<>
                    <Table.Cell>{Items.qC_Approved}</Table.Cell>
                    <Table.Cell>{Items.fqA_Approved}</Table.Cell>
                    <Table.Cell>{Items.cqC_Approved}</Table.Cell>
                    </>)}
                    <Table.Cell>{Items.title_Status}</Table.Cell>
                    <Table.Cell>{Items.owner}</Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
          <br />
          <br />
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(Cutliststatusreport);
